var HGT=window.hgI18n||{};
function hgt(k,d){return HGT[k]||d}
document.querySelectorAll('[data-hg-product]').forEach(function(root){
  if(root.dataset.ready)return;
  root.dataset.ready='1';

  var hidden=root.querySelector('[data-hg-primary]');
  var bundles=root.querySelectorAll('[data-hg-bundle]');
  var mobilePrice=root.querySelector('[data-hg-mobile-price]');
  var mobileLabel=root.querySelector('[data-hg-mobile-label]');
  var image=root.querySelector('.hg-product__main-media img');
  var mobileSource=root.querySelector('.hg-product__main-media picture source');
  var buyNow=root.querySelector('[data-hg-buy-now]');
  var mobileBuy=root.querySelector('[data-hg-mobile-buy]');
  var thumbs=root.querySelectorAll('[data-hg-thumb]');
  var styles=root.querySelector('.hg-product__styles');
  var warmedMedia={};

  function money(c){
    try{return new Intl.NumberFormat(document.documentElement.lang||undefined,{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||root.dataset.hgCurrency||'USD'}).format((Number(c)||0)/100)}
    catch(e){return '$'+((Number(c)||0)/100).toFixed(2)}
  }

  function getQty(){
    var b=root.querySelector('[data-hg-bundle]:checked');
    return Math.max(1,Math.min(3,Number(b?b.value:1)||1));
  }

  function factorFor(n){
    var b=root.querySelector('[data-hg-bundle][value="'+n+'"]');
    var f=Number(b&&b.dataset.factor||1);
    return f>10?f/10000:f;
  }

  function getVariant(i){
    return root.querySelector('[data-hg-variant][data-item-index="'+i+'"]:checked');
  }

  function mediaKey(url){
    if(!url)return '';
    try{
      var u=new URL(url,window.location.href);
      u.searchParams.delete('width');
      u.searchParams.delete('format');
      return u.href;
    }catch(e){
      return String(url).replace(/([?&])width=\d+(&|$)/,'$1').replace(/[?&]$/,'');
    }
  }

  function mediaUrl(url,width){
    if(!url)return '';
    try{
      var u=new URL(url,window.location.href);
      u.searchParams.set('width',String(width));
      u.searchParams.set('format','pjpg');
      return u.href;
    }catch(e){
      var clean=String(url).replace(/([?&])width=\d+(&|$)/,'$1').replace(/[?&]$/,'');
      return clean+(clean.indexOf('?')>-1?'&':'?')+'width='+width+'&format=pjpg';
    }
  }

  function applyMediaUrl(url){
    if(!image||!url)return;
    image.src=url;
    image.srcset='';
    if(mobileSource){
      mobileSource.srcset=mediaUrl(url,360)+' 360w, '+mediaUrl(url,540)+' 540w, '+mediaUrl(url,720)+' 720w';
      mobileSource.sizes='100vw';
    }
  }

  function warmMedia(index){
    if(!thumbs.length)return;
    var next=(index+thumbs.length)%thumbs.length;
    var url=thumbs[next].dataset.hgThumb;
    var src=mediaUrl(url,window.matchMedia('(max-width: 989px)').matches?720:1200);
    if(!src||warmedMedia[src])return;
    warmedMedia[src]=true;
    var loader=new Image();
    loader.decoding='async';
    loader.fetchPriority='low';
    loader.src=src;
  }

  function warmAdjacent(index){
    if(thumbs.length<2)return;
    warmMedia(index+1);
    if(thumbs.length>2)warmMedia(index-1);
  }

  function syncVariantMedia(url){
    if(!image||!url)return;
    var key=mediaKey(url);
    var match=-1;
    for(var i=0;i<thumbs.length;i++){
      if(mediaKey(thumbs[i].dataset.hgThumb)===key){match=i;break}
    }
    if(match>-1)showMedia(match,false);
    else applyMediaUrl(url);
  }

  function compareFor(input){
    if(!input)return 0;
    var p=Number(input.dataset.price||0);
    var c=Number(input.dataset.compare||0);
    return c>p?c:p;
  }

  function sumFor(n){
    var total=0;
    for(var i=1;i<=n;i++){
      var x=getVariant(i);
      if(x)total+=Number(x.dataset.price||0);
      else total+=Number(root.dataset.hgPrice||0);
    }
    return total;
  }

  function compareSumFor(n){
    var total=0;
    for(var i=1;i<=n;i++){
      var x=getVariant(i);
      if(x)total+=compareFor(x);
      else total+=Number(root.dataset.hgCompare||0);
    }
    return total;
  }

  function buildItems(){
    var grouped={};
    var n=getQty();
    for(var i=1;i<=n;i++){
      var x=getVariant(i);
      if(!x){
        if(hidden&&hidden.value) grouped[hidden.value]=(grouped[hidden.value]||0)+1;
        continue;
      }
      if(x.dataset.available!=='true')throw new Error(hgt('soldOut','Item %N% is sold out.').replace('%N%',i));
      var id=String(x.value||'');
      grouped[id]=(grouped[id]||0)+1;
    }
    return Object.keys(grouped).map(function(id){return{id:id,quantity:grouped[id]}});
  }

  function syncItemSummary(input){
    var item=input&&input.closest('[data-hg-item]');
    var summary=item&&item.querySelector('[data-hg-item-summary]');
    if(summary)summary.textContent=input.dataset.title||hgt('selected','Selected style');
  }

  function sync(){
    var n=getQty();

    root.querySelectorAll('.hg-product__bundle').forEach(function(el){el.classList.remove('is-open')});
    var selectedBundleInput=root.querySelector('[data-hg-bundle]:checked');
    var selectedBundleLabel=selectedBundleInput&&selectedBundleInput.closest('.hg-product__bundle');
    if(selectedBundleLabel){
      selectedBundleLabel.classList.add('is-open');
      if(styles&&styles.previousElementSibling!==selectedBundleLabel){
        selectedBundleLabel.insertAdjacentElement('afterend',styles);
      }
    }

    root.querySelectorAll('[data-hg-item]').forEach(function(el){
      el.hidden=Number(el.dataset.hgItem)>n;
    });

    var first=getVariant(1);
    if(first&&hidden){
      hidden.value=first.value;
    }

    [1,2,3].forEach(function(k){
      var original=compareSumFor(k);
      var total=Math.round(sumFor(k)*factorFor(k));
      var p=root.querySelector('[data-hg-bundle-price="'+k+'"]');
      var o=root.querySelector('[data-hg-bundle-original="'+k+'"]');
      var l=root.querySelector('[data-hg-save-label="'+k+'"]');
      var a=root.querySelector('[data-hg-save-amount="'+k+'"]');
      var pct=original>0?Math.max(0,Math.round((1-total/original)*100)):0;
      if(p)p.textContent=money(total);
      if(o){o.textContent=money(original);o.hidden=!(original>total)}
      if(l){l.textContent=pct>0?hgt('save','You save %N%%').replace('%N%',pct):'';l.hidden=!(pct>0)}
      if(a)a.textContent=hgt('saveAmt','SAVE %A%').replace('%A%',money(Math.max(0,original-total)));
    });

    var selectedTotal=Math.round(sumFor(n)*factorFor(n));
    if(mobilePrice)mobilePrice.textContent=money(selectedTotal);
    if(mobileLabel)mobileLabel.textContent=n===1?hgt('m1','BUY 1'):n===2?hgt('m2','BUY 2 — MOST POPULAR'):hgt('m3','BUY 3');
    var cta=n===1?hgt('cta1','BUY IT NOW'):n===2?hgt('cta2','BUY 2 & SAVE'):hgt('cta3','BUY 3 & SAVE');
    if(buyNow)buyNow.textContent=cta;
    if(mobileBuy)mobileBuy.textContent=cta;

    var ok=true;
    for(var i=1;i<=n;i++){
      var x=getVariant(i);
      if(x&&x.dataset.available!=='true')ok=false;
    }
    if(buyNow)buyNow.disabled=!ok;
    if(mobileBuy)mobileBuy.disabled=!ok;
  }

  function goCheckout(){
    try{
      var items=buildItems();
      if(!items.length)throw new Error(hgt('choose','Please choose your style.'));
      var parts=items.map(function(x){return x.id+':'+x.quantity});
      var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
      window.location.assign(base+'cart/'+parts.join(',')+'?checkout');
    }catch(err){
      alert(err.message||hgt('check','Please check your selection.'));
    }
  }

  root.addEventListener('change',function(e){
    if(e.target.matches('[data-hg-variant]')){
      syncItemSummary(e.target);
      if(e.target.dataset.image)syncVariantMedia(e.target.dataset.image);
    }
    if(e.target.matches('[data-hg-variant],[data-hg-bundle]'))requestAnimationFrame(sync);
  });

  root.querySelectorAll('[data-hg-variant]:checked').forEach(syncItemSummary);

  if(buyNow)buyNow.addEventListener('click',goCheckout);
  if(mobileBuy)mobileBuy.addEventListener('click',goCheckout);

  function activeThumbIndex(){
    for(var i=0;i<thumbs.length;i++){
      if(thumbs[i].classList.contains('is-active'))return i;
    }
    return 0;
  }

  function showMedia(index,animate){
    if(!image||!thumbs.length)return;
    var next=(index+thumbs.length)%thumbs.length;
    var t=thumbs[next];
    var thumbImage=t.querySelector('img');
    var apply=function(){
      applyMediaUrl(t.dataset.hgThumb);
      if(thumbImage&&thumbImage.alt)image.alt=thumbImage.alt;
      thumbs.forEach(function(x){x.classList.remove('is-active')});
      t.classList.add('is-active');
      if(t.scrollIntoView)t.scrollIntoView({behavior:'auto',block:'nearest',inline:'center'});
      warmAdjacent(next);
      requestAnimationFrame(function(){image.classList.remove('is-changing')});
    };
    if(animate){
      image.classList.add('is-changing');
      apply();
    }else{
      apply();
    }
  }

  thumbs.forEach(function(t,index){
    t.addEventListener('click',function(){showMedia(index,true)});
  });

  if(image&&thumbs.length>1){
    image.tabIndex=0;
    image.setAttribute('role','button');
    image.setAttribute('aria-label',hgt('swipe','Tap or swipe to view the next product image'));
    var startX=0;
    var tracking=false;
    var suppressClickUntil=0;

    image.addEventListener('pointerdown',function(e){
      if(!window.matchMedia('(max-width: 989px)').matches)return;
      startX=e.clientX;
      tracking=true;
    });

    image.addEventListener('pointerup',function(e){
      if(!tracking)return;
      tracking=false;
      var dx=e.clientX-startX;
      if(Math.abs(dx)<45)return;
      suppressClickUntil=Date.now()+350;
      showMedia(activeThumbIndex()+(dx<0?1:-1),true);
    });

    image.addEventListener('pointercancel',function(){tracking=false});

    image.addEventListener('click',function(){
      if(!window.matchMedia('(max-width: 989px)').matches)return;
      if(Date.now()<suppressClickUntil)return;
      showMedia(activeThumbIndex()+1,true);
    });

    image.addEventListener('keydown',function(e){
      if(e.key==='ArrowRight'){
        e.preventDefault();
        showMedia(activeThumbIndex()+1,true);
      }else if(e.key==='ArrowLeft'){
        e.preventDefault();
        showMedia(activeThumbIndex()-1,true);
      }
    });
  }

  var warmInitial=function(){warmAdjacent(activeThumbIndex())};
  if('requestIdleCallback' in window)window.requestIdleCallback(warmInitial,{timeout:1000});
  else window.setTimeout(warmInitial,120);

  sync();
});

(function(){
  var imgs=document.querySelectorAll('[data-hg-description] img[data-hg-src]');
  if(!imgs.length)return;

  function loadImg(img){
    if(!img||!img.dataset.hgSrc)return;
    var src=img.dataset.hgSrc;
    try{
      if(src.indexOf('cdn.shopify.com')!==-1){
        var u=new URL(src,window.location.href);
        u.searchParams.set('width','900');
        src=u.toString();

        var mk=function(w){
          var x=new URL(img.dataset.hgSrc,window.location.href);
          x.searchParams.set('width',String(w));
          return x.toString();
        };
        img.srcset=mk(480)+' 480w, '+mk(720)+' 720w, '+mk(900)+' 900w';
        img.sizes='(min-width: 990px) 800px, calc(100vw - 24px)';
      }
    }catch(e){}

    img.loading='lazy';
    img.decoding='async';
    img.fetchPriority='low';
    img.src=src;
    img.addEventListener('load',function(){img.classList.remove('hg-deferred-img')},{once:true});
    delete img.dataset.hgSrc;
  }

  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          loadImg(entry.target);
          io.unobserve(entry.target);
        }
      });
    },{rootMargin:'200px 0px'});
    imgs.forEach(function(img){io.observe(img)});
  }else{
    imgs.forEach(loadImg);
  }
})();